// extracted by mini-css-extract-plugin
module.exports = {"testVariant":"UserTestVariant_testVariant__tZ9mW"};